const PageNotFound = () => {
  return (
    <div>
      <div>404 - Page Not Found...</div>
    </div>
  );
};

export default PageNotFound;
